import { render, staticRenderFns } from "./PushCampaignEdit.vue?vue&type=template&id=2220e8ab&scoped=true"
import script from "./PushCampaignEdit.vue?vue&type=script&lang=js"
export * from "./PushCampaignEdit.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PushCampaignEdit.vue?vue&type=style&index=1&id=2220e8ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220e8ab",
  null
  
)

export default component.exports